// produtos-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "* Todos os campos precisam ser preenchidos para realizar as alterações.": "* Todos los campos deben completarse para realizar los cambios.",
    "A entrada e baixa de produtos no estoque devem ser realizadas nas respectivas telas:": "El ingreso y la baja de productos en el stock deben realizarse en las respectivas pantallas:",
    "Aviso": "Aviso",
    "Avisos": "Avisos",
    "Cadastrar nova categoria de produtos": "Registrar nueva categoría de productos",
    "Cadastrar novo produto": "Registrar nuevo producto",
    "Categoria": "Categoría",
    "Categorias de produtos": "Categorías de productos",
    "Controlar estoque": "Controlar stock",
    "Código Serviço Trevo": "Código Servicio Trevo",
    "Depósito": "Depósito",
    "Desativados": "Desactivados",
    "Editar categoria de produto": "Editar categoría de producto",
    "Editar produto": "Editar producto",
    "Erro ao buscar extrato": "Error al buscar el extracto",
    "Erro ao deletar transação": "Error al eliminar la transacción",
    "Erro ao realizar reajuste": "Error al realizar el reajuste",
    "Este campo é utilizado apenas para o relatório de sugestão de compra.": "Este campo se utiliza solo para el reporte de sugerencia de compra.",
    "Estes serão os valores atualizados. Deseja continuar?": "Estos serán los valores actualizados. ¿Desea continuar?",
    "Estoque padrão": "Stock predeterminado",
    "Etiqueta de clientes": "Etiqueta de clientes",
    "Etiquetas de produto": "Etiquetas de producto",
    "Há uma recompensa vinculado a esse produto. Certifique que suas alterações sejam feitas no cadastro do Clube de Vantagens também.": "Hay una recompensa vinculada a este producto. Asegúrese de que sus cambios también se realicen en el registro del Club de Beneficios.",
    "Integrar com EVO": "Integrar con EVO",
    "Integrar com Sanvitron": "Integrar con Sanvitron",
    "Mostruário": "Muestrario",
    "Nenhum local cadastrado para este produto.": "No hay ninguna ubicación registrada para este producto.",
    "Nenhuma": "Ninguna",
    "Nenhuma movimentação do produto": "Ningún movimiento del producto",
    "O cadastro de brindes agora é feito no": "El registro de premios ahora se hace en el",
    "Ofertas de Produtos": "Ofertas de Productos",
    "Os valores atualizados devem ser maior que 0": "Los valores actualizados deben ser mayores que 0",
    "Ponto de Troca": "Punto de Canje",
    "Pontos de Troca": "Puntos de Canje",
    "Posição na tela inicial do App": "Posición en la pantalla inicial de la aplicación",
    "Produto de Venda": "Producto de Venta",
    "Produtos da Oferta": "Productos de la Oferta",
    "Produtos ocultos": "Productos ocultos",
    "Quantidade Movimentada": "Cantidad Movida",
    "Quantidade mínima (litros)": "Cantidad mínima (litros)",
    "Reajuste realizado com sucesso": "Reajuste realizado con éxito",
    "Resgates por dia": "Canjes por día",
    "Selecionar todos os locais": "Seleccionar todas las ubicaciones",
    "Tipo de ação": "Tipo de acción",
    "Transação removida": "Transacción eliminada",
    "Validar em outro local": "Validar en otra ubicación",
    "Valor Anterior": "Valor Anterior",
    "Valor Atualizado": "Valor Actualizado",
    "Valor do Desconto(%)": "Valor del Descuento(%)",
    "Valor do desconto(%)": "Valor del descuento(%)",
    "Valor em reais (Parceiro)": "Valor en reales (Socio comercial)",
};

export default catalogo;
